//#region src/shared/browser.ts
const isBrowser = typeof document !== "undefined";

//#endregion
export { isBrowser };
//# sourceMappingURL=browser.js.map